// src/config.js
export const API_BASE = "https://api.deadringersportal.vivbi.com"; // change once here later to use your domain or HTTPS
// export const API_BASE = "http://localhost:8000"; // change once here later to use your domain or HTTPS
